import React, { useCallback, useMemo } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import Text from 'design-system/Text';
import { AppView, NavigationHeader, hitSlop, rem } from 'design-system';
import IconClose from 'design-system/icons/IconClose';
import useColors from 'hooks/useColors';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import { Tier } from 'features/premium/entities';
import Animated, { useAnimatedScrollHandler, useSharedValue } from 'react-native-reanimated';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import StatusBar from 'design-system/StatusBar';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { isIOS, isWeb } from '../../../constants';
const titles = [
    'Commission',
    'FX fee',
    'Securities custody',
    'Bank transfer in',
    'Bank transfer out',
    'W8-BEN',
    'SEC',
    'FINRA',
    'ADR',
];
const FXFeeRow = ({ title1, title2, title3, title4, title5 }) => {
    const colors = useColors();
    return (<View style={styles.row}>
      <View style={styles.columnTextWrapper}>
        <Text Text-14>{title1}</Text>
      </View>
      <View style={styles.column1}>
        {title2 ? <Text Text-14>{title2}</Text> : <IconClose color={colors.elements.secondaryTransparent}/>}
      </View>
      <View style={styles.column2}>
        {title3 ? <Text Text-14>{title3}</Text> : <IconClose color={colors.elements.secondaryTransparent}/>}
      </View>
      <View style={styles.column3}>
        {title4 ? <Text Text-14>{title4}</Text> : <IconClose color={colors.elements.secondaryTransparent}/>}
      </View>
      <View style={styles.column4}>
        {title5 ? <Text Text-14>{title5}</Text> : <IconClose color={colors.elements.secondaryTransparent}/>}
      </View>
    </View>);
};
const FXInfoScreen = () => {
    const colors = useColors();
    const scrollY = useSharedValue(0);
    const styles = useStyles(styleSet);
    const navigation = useMainStackNavigation();
    const fxFeeMap = useAppSelector((state) => state.invest.tierFxRateMap);
    const scrollHandler = useAnimatedScrollHandler((handle) => {
        scrollY.value = handle.contentOffset.y;
    });
    const onDismiss = useCallback(() => {
        navigation.pop();
    }, []);
    const headerLeft = useMemo(() => (<TouchableOpacity hitSlop={hitSlop} onPress={onDismiss} style={styles.closeButton}>
        <IconClose alt color={colors.elements.secondary}/>
      </TouchableOpacity>), [colors.elements.secondary, onDismiss, styles.closeButton]);
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    return (<AppView type="primary" withFrame={false}>
      <StatusBar animated barStyle="dark-content"/>
      <NavigationHeader scrollY={scrollY} title="Pricing" leftContent={headerLeft} outputColors={[colors.background.light, colors.cards.onDark]} withFrame>
        <FXFeeRow title1="Fee" title2="Basic" title3="Plus" title4="Pro" title5="Ultimate"/>
      </NavigationHeader>
      <Animated.ScrollView onScroll={scrollHandler} scrollEventThrottle={16}>
        {titles.map((title, index) => {
            if (!fxFeeMap && title === 'FX fee')
                return null;
            return (<View style={[index % 2 === 0 && styles.coloredBg, paddingHorizontalStyle]} key={title}>
              {title === 'FX fee' ? (<FXFeeRow title1={title} title2={<Text Numbers-14>{fxFeeMap?.[Tier.free]}%</Text>} title3={<Text Numbers-14>{fxFeeMap?.[Tier.plus]}%</Text>} title4={<Text Numbers-14>{fxFeeMap?.[Tier.pro]}%</Text>} title5={<Text Numbers-14>{fxFeeMap?.[Tier.ultimate]}%</Text>}/>) : (<FXFeeRow title1={title}/>)}
            </View>);
        })}
      </Animated.ScrollView>
    </AppView>);
};
export default FXInfoScreen;
const styleSet = createStyleSheets((colors) => ({
    coloredBg: {
        backgroundColor: colors.cards.onLight,
    },
    closeButton: {
        width: rem(44),
        height: rem(44),
        alignItems: 'center',
        alignSelf: 'flex-start',
        justifyContent: 'center',
        marginLeft: isIOS ? -15 : -5,
    },
}));
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        paddingHorizontal: rem(16),
    },
    columnTextWrapper: {
        flex: 1,
        paddingVertical: rem(16),
        justifyContent: 'center',
    },
    column1: {
        flex: 0,
        flexBasis: 54,
        alignItems: 'center',
        justifyContent: 'center',
    },
    column2: {
        flex: 0,
        flexBasis: 54,
        alignItems: 'center',
        justifyContent: 'center',
    },
    column3: {
        flex: 0,
        flexBasis: 54,
        alignItems: 'center',
        justifyContent: 'center',
    },
    column4: {
        flex: 0,
        flexBasis: 64,
        alignItems: 'center',
        justifyContent: 'center',
    },
});
